import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { ICampusPaper } from '@/src/types/resumeDetail/campusType';

import './index.scss';

interface IProps {
  data: ICampusPaper[];
  setMode: Function;
}

// 仅校招
const PaperView: FC<IProps> = (props) => {
  const { data, setMode } = props;
  const { campusResumeFormRefStore } = useRootStore();

  const storeRef = campusResumeFormRefStore;

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('paper_edit');
  };

  return (
    <div className="paper_view">
      <div className="model_title">
        <div>论文</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {data?.map((item) => (
        <div className="model_list model_view" key={item.renderId}>
          <div className="model_top">
            <div className="thesis_name">{item.thesisName}</div>
          </div>
          <div className="model_line" />
          <div className="model_bottom">
            <div className="label thesis_level_name">
              发表渠道：<span>{item.thesisLevelName}</span>
            </div>
            <div className="label author_order">
              作者顺序：<span>{item.authorOrderName}</span>
            </div>
            <div className="label">
              影响因子：<span>{item.influenceFactor || '-'}</span>
            </div>
            <div className="label">
              项目链接： {item.thesisUrl ? <a href={item.thesisUrl}>{item.thesisUrl}</a> : '-'}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaperView;
